import React from 'react';
import { string, bool, number, arrayOf, shape } from 'prop-types';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { getAmplitudeInstance } from '@alltrails/shared/utils/amplitudeHelpers';
import { ACTIVITY_TYPES } from 'utils/constants/PageSection';
import { HOMEPAGE_SIGNUP_BUTTON_TAPPED } from 'utils/constants/AmplitudeEvent';
import { EN_US } from 'utils/constants/LanguageRegionCode';
import ActivitySuitabilityRiver from './ActivitySuitabilityRiver';
import * as styles from './styles/styles.module.scss';

const {
  strings: {
    SIGNUP: { SIGNUP },
    HOME_PAGE: {
      SUITABILITY_BLOCK: { BUILT_FOR_EVERYONE, WHETHER_YOURE_LOOKING }
    }
  }
} = StringConstantsMixin;

const SignupActivitySuitability = ({ activities, languageRegionCode, mobileBrowser, windowWidth }) => {
  return (
    <div className={styles.container}>
      <div className={styles.signUp}>
        <h3 className={styles.header}>{BUILT_FOR_EVERYONE}</h3>
        <div className={styles.subText}>{WHETHER_YOURE_LOOKING}</div>
        <a
          className={styles.link}
          href={LanguageSupportUtil.wrapUrlSafe('/signup?ref=homepage_signup_signupactivitysuitability', languageRegionCode)}
          onClick={() => getAmplitudeInstance().logEvent(HOMEPAGE_SIGNUP_BUTTON_TAPPED, { 'page section': ACTIVITY_TYPES })}
        >
          {SIGNUP}
        </a>
      </div>
      <div className={styles.activityCarousel}>
        <ActivitySuitabilityRiver activities={activities} mobileBrowser={mobileBrowser} windowWidth={windowWidth} />
      </div>
    </div>
  );
};

SignupActivitySuitability.propTypes = {
  languageRegionCode: string,
  mobileBrowser: bool,
  windowWidth: number,
  activities: arrayOf(
    shape({
      title: string,
      explore_url: string,
      photo_urls: shape({
        square: shape({
          two: string,
          three: string
        })
      })
    })
  ).isRequired
};

SignupActivitySuitability.defaultProps = {
  languageRegionCode: EN_US,
  mobileBrowser: true,
  windowWidth: null
};

export default SignupActivitySuitability;
